import React from 'react';
import MeasuredGrid, { Props as MeasuredGridProps } from './MeasuredGrid';
import { adjustBreakpointHeight, DEFAULT_BREAKPOINTS } from './breakpoints';

export interface Props
  extends Rename<MeasuredGridProps, 'renderElement', 'children'> {
  adjustHeight?: number;
}

export const StandardGrid: React.FC<Props> = ({
  adjustHeight = 0,
  breakpoints = DEFAULT_BREAKPOINTS,
  children,
  ...props
}) => (
  <MeasuredGrid
    {...props}
    breakpoints={
      adjustHeight
        ? adjustBreakpointHeight(breakpoints, adjustHeight)
        : breakpoints
    }
    renderElement={children}
  />
);

export default StandardGrid;
